import { createFileRoute } from '@tanstack/react-router';
import { RolesPage } from '../../features/settings/components/roles-page.js';

export const Route = createFileRoute('/admin/roles')({ component: RolesPage });
